// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LeadText-module__LeadText___gtYJk {\n  font-size: 12px;\n  font-family: \"Hiragino Sans\", \"Hiragino Kaku Gothic ProN\", Meiryo, \"sans-serif\";\n  font-weight: 500;\n  color: #7A7775;\n}\n\n.LeadText-module__wrapper___ApeD- {\n  display: flex;\n  padding-top: 8px;\n  grid-gap: 8px;\n  grid-gap: 8px;\n  gap: 8px;\n  align-items: center;\n  text-align: left;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"LeadText": "LeadText-module__LeadText___gtYJk",
	"leadText": "LeadText-module__LeadText___gtYJk",
	"wrapper": "LeadText-module__wrapper___ApeD-"
};
export default ___CSS_LOADER_EXPORT___;
